// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EX-n","label":"styles_label__3mNYJ"};